module.exports = __webpack_public_path__ + "images/yamaha_smalla611f36effbd81fca074359ecff9403c.png";